import React from 'react';
import {
  STUDENT_STATUS_LABEL,
  StudentStatusEnum,
} from '../../../constants/types/student-type';

export const StudentStatusTag = ({
  studentStatus,
}: {
  studentStatus: StudentStatusEnum;
}) => {
  const bgColor =
    studentStatus === StudentStatusEnum.ACTIVE
      ? 'bg-purple0'
      : studentStatus === StudentStatusEnum.INACTIVE
        ? 'bg-gray-200'
        : 'bg-yellow-100';
  const textColor =
    studentStatus === StudentStatusEnum.ACTIVE
      ? 'text-purple5'
      : studentStatus === StudentStatusEnum.INACTIVE
        ? 'text-gray-700'
        : 'text-yellow-900';
  return (
    <span
      className={`flex items-center rounded-lg ${bgColor} px-2.5 py-1 text-caption1 font-semibold ${textColor}`}
    >
      {STUDENT_STATUS_LABEL[studentStatus]}
    </span>
  );
};
